import React, { useState } from 'react';
import Button from '../../../muiComponents/Button';
import { useZitoneoServices } from '../contexts/ZitoneoContentContext';
import useTranslate from '../../../customHooks/useTranslate';
import { useHistory } from 'react-router-dom';
import { useZitoneoUI } from '../contexts/ZitoneoUIContext';
import UnsavedServicesChangesPopUp from '../hotelContent/detail/header/UnsavedServicesChangesPopUp';
import routes from '../../../utils/commonVariables/routes';
import StatusIndicator from '../hotelContent/detail/settings/StatusIndicator';
import Tooltip from '../../../muiComponents/Tooltip';
import { ZitoneoViewMode } from '../types/zitoneoServicesTypes';

const ZitoneoFooter = () => {
    const translate = useTranslate();
    const history = useHistory();
    const [isWarningOpen, setIsWarningOpen] = useState(false);

    const { saveHotelContent, hasUnsavedChanges } = useZitoneoServices();
    const { isLoading, changeViewMode } = useZitoneoUI();

    const backToHome = () => {
        history.push(routes.zitoneo + routes.zitoneoHotelsContent);
    };

    const handleBackToHome = () => {
        if (isLoading) {
            return;
        }

        if (hasUnsavedChanges) {
            setIsWarningOpen(true);
        } else {
            backToHome();
        }
    };

    const goToSettings = () => {
        changeViewMode(ZitoneoViewMode.SETTINGS);
    };

    return (
        <>
            <footer className='hotel-content-services__footer'>
                <Button
                    startIcon='ArrowBack'
                    onClick={handleBackToHome}
                    disabled={isLoading}
                >
                    {translate('back_to_properties')}
                </Button>
                <div className='flex flex-align-center gap-40'>
                    <div className='flex flex-align-center gap-20'>
                        <Tooltip titleText='publication_status_tooltip'>
                            <div
                                className='cursor-pointer'
                                onClick={goToSettings}
                            >
                                <StatusIndicator isLoading={isLoading} />
                            </div>
                        </Tooltip>
                    </div>
                    <Button
                        onClick={() => saveHotelContent()}
                        variant='contained'
                        disabled={isLoading}
                    >
                        {translate('save')}
                    </Button>
                </div>
            </footer>
            <UnsavedServicesChangesPopUp
                isOpen={isWarningOpen}
                onClose={async () => {
                    setIsWarningOpen(false);
                    backToHome();
                }}
                onSave={async () => {
                    await saveHotelContent();
                    setIsWarningOpen(false);
                }}
            />
        </>
    );
};

export default ZitoneoFooter;
